import { useQuery } from '@apollo/react-hooks';
import { useCountry } from '../../components/CountrySelector';
import {
  GET_REWARDS_SUMMARY_QUERY,
  GetRewardsSummaryQuery,
  GetRewardsSummaryQueryVariables
} from './rewardsSummary.rest';

export const useRewardsSummary = (currency?: string) => {
  const { country } = useCountry();
  const { data, loading, error } = useQuery<
    GetRewardsSummaryQuery,
    GetRewardsSummaryQueryVariables
  >(GET_REWARDS_SUMMARY_QUERY, {
    variables: { countryCode: country.alpha2Code, currency: currency }
  });

  return {
    rewards: data?.getRewardsSummary.data,
    loading,
    error
  };
};
